import axios from "axios";


export function requestTokenize(text) {
    return axios.post("https://api.cltk.clementbesnier.eu/tokenizers/non/", {text});
}

export function requestLookupDictionary(token) {
    return axios.get(`https://api.cltk.clementbesnier.eu/dictionary/cltk_non_zoega_dictionary/?token=${token}`)
}